/**
 * Subscription Cancel Page
 * Shown when user cancels payment
 */

import React from 'react';
import SubscriptionLayout from '../components/subscription/SubscriptionLayout';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

const SubscriptionCancelPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <SubscriptionLayout>
            <div className="flex items-center justify-center min-h-[60vh] p-4">
                <div className="max-w-md w-full bg-white dark:bg-slate-800 rounded-2xl shadow-xl p-8 text-center">
                    <div className="flex justify-center mb-6">
                        <div className="w-16 h-16 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center">
                            <XCircle className="w-10 h-10 text-red-600 dark:text-red-400" />
                        </div>
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                        Payment Cancelled
                    </h2>
                    <p className="text-gray-600 dark:text-gray-300 mb-6">
                        Your payment was cancelled. No charges were made. You can try again anytime.
                    </p>
                    <div className="flex gap-4">
                        <button
                            onClick={() => navigate('/subscription')}
                            className="flex-1 px-4 py-2 bg-gray-200 dark:bg-slate-600 text-gray-700 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-slate-500 flex items-center justify-center"
                        >
                            <ArrowLeft className="w-4 h-4 mr-2" />
                            Back to Dashboard
                        </button>
                        <button
                            onClick={() => navigate('/onboarding')}
                            className="flex-1 px-4 py-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-lg hover:from-purple-700 hover:to-pink-700"
                        >
                            Try Again
                        </button>
                    </div>
                </div>
            </div>
        </SubscriptionLayout>
    );
};

export default SubscriptionCancelPage;

